export const PHOTOS_LIST = ["BANNER_IMAGES","FOOTER_IMAGES","HIGHTLIGHTS"]